import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=26a01aa6&"
import script from "./ItemTable.vue?vue&type=script&lang=js&"
export * from "./ItemTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=26a01aa6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports